import React from 'react';
import { getTranslations } from '../services/translations';

const NotFound: React.FC = () => {
  // No company context on this route, so fall back to the browser language
  const translations = getTranslations(navigator.language || 'es-es');

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
        <p className="text-gray-600 mb-8">{translations['not_found.title'] || 'Page not found'}</p>
        <a 
          href="/" 
          className="inline-flex items-center px-4 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition"
        >
          Go Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
